module.exports = __webpack_public_path__ + "static/media/coin.fdbcfe02.svg";